module.exports = __webpack_public_path__ + "img/caution_button.d8f065ba.png";